import React from "react";
import { Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const FullTextHelp = () => {
  const fullTextHelp = (
    <table>
      <tbody>
        <tr>
          <td>
            <strong>Symbol</strong>
          </td>
          <td>
            <strong>Operation</strong>
          </td>
        </tr>
        <tr>
          <td>
            <code>&quot;</code>
          </td>
          <td>exact phrase</td>
        </tr>
        <tr>
          <td>
            <code>+</code> or <code>&lt;space&gt;</code>
          </td>
          <td>AND</td>
        </tr>
        <tr>
          <td>
            <code>|</code>
          </td>
          <td>OR</td>
        </tr>
        <tr>
          <td>
            <code>-</code>
          </td>
          <td>NOT</td>
        </tr>
        <tr>
          <td>
            <code>( )</code>
          </td>
          <td>groups search terms or operations</td>
        </tr>
        <tr>
          <td>
            <a href="https://support.unifiedpatents.com/hc/en-us/articles/8263935234071" target="_new">
              More details here.
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  )
  return (
    <Popover placement="rightBottom" title={"Advanced Query Syntax"} content={fullTextHelp} trigger="click">
      <QuestionCircleOutlined style={{ cursor: "pointer" }} />
    </Popover>
  )
};

export default FullTextHelp;
